"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const getState_1 = require("../helpers/getState");
const command_1 = require("../type/command");
const entity_1 = require("../type/entity");
const getShortId_1 = tslib_1.__importDefault(require("./helpers/getShortId"));
function addApproverId(command, certificateData) {
    if (command.type === command_1.CommandType.EVALUATE_CHECKPOINT) {
        certificateData.approverId = command.creatorId;
    }
}
function getCertificateSettings(content) {
    const certificateSettings = content.contentSettings.certificateSettings;
    return certificateSettings;
}
function getCertificateData(command, state) {
    const certificateData = {
        completionDate: state.completedOn,
        score: state.scaledScore || 0
    };
    addApproverId(command, certificateData);
    return certificateData;
}
function getCertificateURL(issueId) {
    return `https://d3jznrqwkjyz7g.cloudfront.net/${issueId}.png`;
}
function getCertificateObject(command, content, state) {
    const certificateSettings = getCertificateSettings(content);
    const certificateData = getCertificateData(command, state);
    const issueId = getShortId_1.default();
    const certificateURL = getCertificateURL(issueId);
    const { certificateTemplateId } = content.contentSettings;
    const { timeStamp: issuedDate } = command;
    return {
        certificateSettings,
        certificateData,
        certificateTemplateId,
        issueId,
        certificateURL,
        issuedDate
    };
}
function attachCertificateToState(command, content, state) {
    try {
        if (!state.certificates) {
            state.certificates = [];
        }
        const certificate = getCertificateObject(command, content, state);
        state.certificates.unshift(certificate);
        return state;
    }
    catch (error) {
        throw new Error('Error in addCertificateToState ' + error);
    }
}
function issueCertificate(command, user, content, states) {
    try {
        if (!content.contentSettings) {
            return;
        }
        const isCertificateEnabled = content.contentSettings.certificateEnabled;
        if (!isCertificateEnabled) {
            return;
        }
        const contentId = content._id;
        const state = getState_1.getStateByContentIdUserId(states, contentId, user.userId);
        if (state && state.completionStatus === entity_1.CompletionStatus.COMPLETE) {
            attachCertificateToState(command, content, state);
        }
    }
    catch (error) {
        throw new Error('Error in issuing certificate ' + error);
    }
}
exports.default = issueCertificate;
//# sourceMappingURL=issueCertificate.js.map